export enum USER_SETTINGS {
  MESSAGE_SETTINGS = "scrile-connect.MessageSetting",
}

export default function() {
  const getUserSetting = (key: USER_SETTINGS) => {
    return JSON.parse(sessionStorage.getItem(key) as string);
  };

  const setUserSetting = (key: USER_SETTINGS, newSettings: Record<string, any>) => {
    sessionStorage.setItem(key, JSON.stringify(newSettings));
  };

  const removeUserSetting = (key: USER_SETTINGS) => {
    sessionStorage.removeItem(key);
  };

  return {
    getUserSetting,
    setUserSetting,
    removeUserSetting,
  };
}
